module.exports = __webpack_public_path__ + "img/spinner-icon.f94f38b2.svg";